module.exports = __webpack_public_path__ + "img/stock.9b572b59.png";